import {initWebComponent} from "@/helpers/web-component-helper";
import {CesiumMeasureButtonComponent} from "@/components/cesium/buttons/cesium-measure-button-component";
import {CesiumToggleDepthButtonComponent} from "@/components/cesium/buttons/cesium-toggle-depth-button-component";
import {
    CesiumToggleCameraUnderTerrainComponent
} from "@/components/cesium/buttons/cesium-toggle-camera-under-terrain-component";
import {CesiumTerrainTransparencyComponent} from "@/components/cesium/buttons/cesium-terrain-transparency-component";
import {initBoostrapSlider} from "@/helpers/bootstrap-slider-helper.js";
import Slider from "bootstrap-slider";
import {CesiumToggleShadowComponent} from "@/components/cesium/buttons/cesium-toggle-shadow-component.js";

export class LayerInfoTools3dComponent extends HTMLElement {
    constructor(){
        super();

        const template = document.createElement('template');
        template.innerHTML = `
     
         <div class="card ml-2 mt-2 mr-2 mb-1">
                <div class="card-header p-2">
                  <a href="#" class="font-weight-bold text-dark accordion-header d-block" data-bs-target="#collapseLegend0" data-bs-toggle="collapse" aria-expanded="true">
                    Meten
                    <div class="collapse-icon float-right"></div>
                  </a>
                </div>
                <div id="collapseLegend0" class="collapse show pb-2 pt-2" data-parent="#collapseLegend" style="">
                  <div class="card-body pl-2 pr-2">
                     <cesium-measure-button></cesium-measure-button>
                  </div>
                </div>
            </div>    
            
         <div class="card ml-2 mt-2 mr-2 mb-1">
                <div class="card-header p-2">
                  <a href="#" class="font-weight-bold text-dark accordion-header d-block" data-bs-target="#collapseLegend1" data-bs-toggle="collapse" aria-expanded="true">
                    Terrein
                    <div class="collapse-icon float-right"></div>
                  </a>
                </div>
                <div id="collapseLegend1" class="collapse show pb-2 pt-2" data-parent="#collapseLegend" style="">
                  <div class="card-body pl-2 pr-2">
                     <div>
                        <cesium-toggle-camera-under-terrain></cesium-toggle-camera-under-terrain>
                     </div>
                      <div class="mt-2">
                        <cesium-toggle-depth-button></cesium-toggle-depth-button>
                     </div>
                   </div>
                </div>
            </div>  
                      
         <div class="card ml-2 mt-2 mr-2 mb-1">
                <div class="card-header p-2">
                  <a href="#" class="font-weight-bold text-dark accordion-header d-block" data-bs-target="#collapseLegend1" data-bs-toggle="collapse" aria-expanded="true">
                    Schaduw
                    <div class="collapse-icon float-right"></div>
                  </a>
                </div>
                <div id="collapseLegend1" class="collapse show pb-2 pt-2" data-parent="#collapseLegend" style="">
                  <div class="card-body pl-2 pr-2">
                    <cesium-toggle-shadow></cesium-toggle-shadow>
                   </div>
                </div>
            </div>
        `;

        initWebComponent(this, template)
    }
}

window.customElements.define("cesium-measure-button", CesiumMeasureButtonComponent);
window.customElements.define("cesium-toggle-depth-button", CesiumToggleDepthButtonComponent);
window.customElements.define("cesium-toggle-camera-under-terrain", CesiumToggleCameraUnderTerrainComponent);
window.customElements.define("cesium-terrain-transparency", CesiumTerrainTransparencyComponent);
window.customElements.define("cesium-toggle-shadow", CesiumToggleShadowComponent);
